module.exports = __webpack_public_path__ + "img/payments.monthly.0c39aa9f.png";